import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        headDate: {
            index: 0, //默认 今日
        },
        leftTopNavIndex: 0,
        baseInfoLayer: {
            listStatus: false,
            detailStatus: false,
            baseInfoId: '',
            baseInfoItem: {},
            baseInfoTitle: '',
        },
        eventStatis: {
            status: false,
            id: '',
            type: '',
            item: {}
        },
        showDetail: {
            status: false,
            item: {},
        },
        showMap: {
            status: false,
            position: null,
        },
        showCrtMap: {
            status: false,
            item: {},
        },
        monitor: {
            status: false,
            id: '',
            type: '',
            item: {}
        },
        showLayer: {
            status: false,
            type: '',
            navIndex: '',
        },
        departInfoLayer: 1,
        notIndustryCategory: null,
        mqttapi:''
    },
    mutations: {
        setNotIndustryCategory(state, index) {
            state.notIndustryCategory = index;
        }
        ,
        setmqttapi(state, index) {
             state.mqttapi = index;
         },
        setHeadDate(state, index) {
            state.headDate.index = index;
        }
        ,
        leftTopNavIndex(state, index) {
            state.leftTopNavIndex = index;
        }
        ,
        departInfoLayer(state, index) {
            state.departInfoLayer = index;
        }
        ,
        baseInfoLayer(state, obj) {
            for (let i = 0; i < Object.keys(obj).length; i++) {
                state.baseInfoLayer[Object.keys(obj)[i]] = obj[Object.keys(obj)[i]];
            }
        }
        ,
        eventStatis(state, obj) {
            for (let i = 0; i < Object.keys(obj).length; i++) {
                state.eventStatis[Object.keys(obj)[i]] = obj[Object.keys(obj)[i]];
            }
        }
        ,
        showDetail(state, obj) {
            for (let i = 0; i < Object.keys(obj).length; i++) {
                state.showDetail[Object.keys(obj)[i]] = obj[Object.keys(obj)[i]];
            }
        }
        ,
        showMap(state, obj) {
            for (let i = 0; i < Object.keys(obj).length; i++) {
                state.showMap[Object.keys(obj)[i]] = obj[Object.keys(obj)[i]];
            }
        }
        ,
        showCrtMap(state, obj) {
            for (let i = 0; i < Object.keys(obj).length; i++) {
                state.showCrtMap[Object.keys(obj)[i]] = obj[Object.keys(obj)[i]];
            }
        }
        ,
        monitor(state, obj) {
            for (let i = 0; i < Object.keys(obj).length; i++) {
                state.monitor[Object.keys(obj)[i]] = obj[Object.keys(obj)[i]];
            }
        }
        ,
        showLayer(state, obj) {
            for (let i = 0; i < Object.keys(obj).length; i++) {
                state.showLayer[Object.keys(obj)[i]] = obj[Object.keys(obj)[i]];
            }
        }
    }
});
export default store;


// WEBPACK FOOTER //
// ./src/store/index.js